/**
* 馨康宝
*
* @author 张毅
*
*/
<template>
	<ul>
		<li>
			<div style="width: 100%; text-align: center;">
				<van-tag :type="license.verify ? 'success' : 'danger'" size="large">
					{{license.verify ? '有效' : '失效'}}许可
				</van-tag>
				<van-tag :type="license.accsn ? 'success' : 'danger'" size="large">{{license.accsn ? '有效' : '失效'}}序号
				</van-tag>
				<van-tag :type="!license.expire ? 'success' : 'danger'" size="large">
					{{!license.expire ? '有效' : '失效'}}期限
				</van-tag>
			</div>
		</li>
		<li>
			<label>版权产品：</label>
			<label>{{license.product}}</label>
		</li>
		<li>
			<label>版权所有：</label>
			<label>{{license.owner}}</label>
		</li>
		<li>
			<label>版权声明：</label>
			<label>{{license.copyright}}</label>
		</li>
		<li>
			<label>被授权方：</label>
			<label>{{license.licensee}}</label>
		</li>
		<li>
			<label>许可序号：</label>
			<label>{{license.serial}}</label>
		</li>
		<li>
			<label>许可期限：</label>
			<label>从【{{license.beginDate}}】至【{{license.stopDate || '不限'}}】，共【{{license.validity || '不限'}}】天</label>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'License',
		props: {
			license: {
				type: Object,
				required: true
			}
		}
	}
</script>

<style scoped="scoped">
	
	ul li {
		padding: 15px 0;
		border-bottom: 1px dashed #E4E4E4;
		display: flex;
	}

	ul li:last-child {
		border-bottom: none;
	}

	ul li label {
		font-size: 12px;
		line-height: 1.6;
	}

	ul li label:first-child {
		width: 4.5rem;
		text-align: right;
		margin-right: 5px;
		flex-shrink: 0;
		color: #989898;
	}

	ul li .el-tag {
		margin-right: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/License.vue